import { Modelo } from '@ext/index';
import * as Types from './Recurso.types';
import moment, { Moment } from 'moment';

export class IRecurso extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: number = 0;
    public Turnero: number = 0;
    public Nombre: string = '';
    public Tipo: string = '';
    public Recurso: string = '';


    public getJson(): any
    {
        let json: any = {};

        json.nombre = this.Nombre;
        json.tipo = this.Tipo;
        json.recurso = this.Recurso;
        return json;
    }


    public set(): boolean
    {

        this.Id = !this.Json.id ? 0 : this.Json.id;
        this.Turnero = !this.Json.turnero ? 0 : this.Json.turnero;
        this.Tipo = !this.Json.tipo ? '' : this.Json.tipo;
        this.Nombre = !this.Json.nombre ? '' : this.Json.nombre;
        this.Recurso = !this.Json.recurso ? '' : this.Json.recurso;


        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor( Model: IRecurso )
    {
        this.Model = Model;
    }

    public Model: IRecurso;
}